import { Component, OnInit, AfterViewInit, Inject, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { EpayService } from '../../services/epay.service';

import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-paymentdialog',
  templateUrl: './paymentdialog.component.html',
  styleUrls: ['./paymentdialog.component.css']
})
export class PayParkingPaymentDialogComponent implements OnInit, AfterViewInit {

    constructor(public dialogRef: MatDialogRef<PayParkingPaymentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private route: ActivatedRoute,
        private epayService: EpayService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
    }
}
